import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import coverVideo from "../assets/cover_video.mp4";
import { motion } from "framer-motion";

const Home_Cover = () => {
  const textVariants = {
    hidden: { x: -50, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        delay: i * 0.5, // delay each line
        ease: "easeOut",
      },
    }),
  };
  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "420px", md: "750px" },
          overflow: "hidden",
        }}
      >
        {/* Background Video */}
        <Box
          component="video"
          autoPlay
          loop
          muted
          playsInline
          src={coverVideo}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            minWidth: "100%",
            minHeight: "100%",
            width: "auto",
            height: "auto",
            objectFit: "cover",
            zIndex: -1,
          }}
        />

        {/* Dark overlay for readability */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.45)",
            zIndex: 2,
          }}
        />

        {/* Text Content */}
        <Container
          sx={{
            position: "relative",
            zIndex: 3,
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box className="cover-text">
            <motion.h1
              custom={0}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              We Building
              {/* We're Building */}
            </motion.h1>

            <motion.h1
              custom={2}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              For Better
            </motion.h1>

            <motion.h1
              custom={3}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              Future.
            </motion.h1>

            {/* <motion.p
              custom={4}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              We build infrastructure with passion and dedication to create a
              better and brighter future for everyone.
            </motion.p> */}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Home_Cover;
